const platforms = [
  {
    id: 'booking',
    homeUrl: process.env.REACT_APP_BOOKING_HOME_URI,
    displayOnHomepage: false
  },
  {
    id: 'decipher',
    title: 'Decipher',
    displayOnHomepage: true,
    loginUrl: 'https://selfserve.decipherinc.com/login',
    signupUrl: `/sign-up?client_id=decipher&confirmation_uri=/login/confirmation&hostname=${
      process.env.REACT_APP_DECIPHER_HOSTNAME
    }&redirect_uri=${encodeURIComponent(
      process.env.REACT_APP_DECIPHER_REDIRECT_URI
    )}`,
    homeUrl: '/',
    supportEmail: 'de-support@focusvision.com'
  },
  {
    id: 'revelation',
    title: 'Revelation',
    displayOnHomepage: true,
    loginUrl: '/login?client_id=revelation',
    loginUrlFn: hostname => `https://researcher.${hostname}`,
    homeUrl: 'https://researcher.studyspace.net/',
    homeUrlFn: hostname => `https://researcher.${hostname}`,
    zendeskHost: 'revelation.zendesk.com',
    supportEmail: 're-support@focusvision.com'
  },
  {
    id: 'vi',
    title: 'VideoInsights',
    displayOnHomepage: true,
    loginUrl: process.env.REACT_APP_VI_LOGIN_URI,
    signupUrl: baseQueryString => `/sign-up${baseQueryString}`,
    homeUrl: process.env.REACT_APP_VI_HOME_URI,
    loginUrlFn: hostname => `https://${hostname}/login`,
    homeUrlFn: hostname => `https://${hostname}`,
    confirmationUri: '/login/confirmation',
    zendeskHost: 'focusvision.zendesk.com',
    supportEmail: 'vi-support@focusvision.com',
    ssoSignUp: true
  },
  {
    id: 'vs',
    title: 'LiveVideo',
    displayOnHomepage: true,
    loginUrl: 'https://online.focusvision.com/account/',
    homeUrl: '/',
    supportEmail: 'support@focusvision.com'
  },
  {
    id: 'kinesis',
    title: 'KinesisPanel',
    displayOnHomepage: true,
    loginUrl: '/login?client_id=kinesis',
    homeUrl: '/',
    homeUrlFn: hostname =>
      `${
        process.env.NODE_ENV === 'development' ? 'http' : 'https'
      }://${hostname}/auth.pro`,
    supportEmail: 'kp-support@focusvision.com'
  },
  {
    id: 'intervu',
    title: 'InterVu',
    displayOnHomepage: true,
    loginUrl: 'https://online.focusvision.com/account/',
    homeUrl: '/',
    supportEmail: 'support@focusvision.com'
  },
  {
    id: 'intervunow',
    homeUrl: process.env.REACT_APP_INTERVU_HOME_URI,
    homeUrlFn: () => process.env.REACT_APP_INTERVU_HOME_URI,
    confirmationUri: '/login/confirmation',
    displayOnHomepage: false
  }
]

export const findPlatform = platformId =>
  platforms.find(platform => platform.id === platformId)

export default platforms



// WEBPACK FOOTER //
// ./src/config/platforms.js